import useStyles from "../styles";
import { useState } from "react";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { useUpload } from "../../../hooks/useUpload";
import Modal from "../../../components/Modal";

const PROFILE_ENDPOINT = "api/v1/profile";
const OrganisationDetails = ({ data }) => {
  const classes = useStyles();
  const [uploadForm, setUploadForm] = useState({});
  const [selectedFile, setSelectedFile] = useState("");
  const [deleteStamp, setDeleteStamp] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [orgDetails, setOrgDetails] = useState({
    school_name: data?.school_name,
    mission: data?.mission,
    vision: data?.vision,
    signature: data?.signature || {},
    staff_count: Number(data?.staff_count)
  });

  const handleDeleteStamp = () => {
    setDeleteStamp(!deleteStamp);
  };

  const handleOrgChange = (e) => {
    const { name, value } = e.target;
    setOrgDetails({ ...orgDetails, [name]: value });
  };
    /**
 * Removes the selected file.
 */
  const handleRemoveFile = () => setSelectedFile("");
  /**
 * Handles file input change and updates file state.
 * @param {Event} e - The file input change event.
 */
  const handleFileChange = (e) => {
    // const { name } = e.target;
    if (e.target.files) setSelectedFile(e.target.files[0]);
    setUploadForm({ ...uploadForm, file: e.target.files[0].name.replaceAll(" ", "-") });
  };

  const handleDeleteSchoolStamp = () => {
    setIsDeleting(true);

    httprequest.patch(PROFILE_ENDPOINT, { signature: {} })
      .then((res) => {
        setIsDeleting(false);
        toast.success(res?.data?.message);
        handleDeleteStamp();

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        setIsDeleting(false);
        toast.error(err?.response?.message || "Something went wrong");
      });
  };

  const updateOrg = async () => {
    setIsLoading(true);

    try {
      const updatedOrgDetails = { ...orgDetails };

      // --- If a signature file is selected, upload it first ---
      if (selectedFile) {
        const response = orgDetails?.signature?.upload_id
          ? await useUpload(selectedFile, orgDetails?.signature?.upload_id)
          : await useUpload(selectedFile);

        if (response.status === 200 && response.data.data) {
          updatedOrgDetails.signature = {
            file_url: response.data.data?.[0]?.file_url,
            upload_id: response.data.data?.[0]?.upload_id
          };
        } else {
          toast.error("Unable to upload signature");
          setIsLoading(false);

          return;
        }
      }

      // --- Patch with updated orgDetails ---
      const res = await httprequest.patch(PROFILE_ENDPOINT, updatedOrgDetails);

      setIsLoading(false);
      toast.success(res?.data?.message);
      window.location.reload();
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <div className="left-container">
          <h4>Organisation Details</h4>
          <h6>Update your personal details here</h6>
        </div>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <div className="right-container">
          <Grid container spacing={2} className={classes.profileform}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="text" label="Organisation Name" inputName="school_name" onChange={handleOrgChange} defaultValue={orgDetails?.school_name} value={orgDetails?.school_name} />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextAreaGroup label="Mission" defaultValue={orgDetails?.mission} inputName="mission" onChange={handleOrgChange} value={orgDetails?.mission} />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TextAreaGroup label="Vision" defaultValue={orgDetails?.vision} inputName="vision" onChange={handleOrgChange} value={orgDetails?.vision} />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <InputGroup inputType="number" label="Total Staff" inputName="staff_count" defaultValue={orgDetails?.staff_count} onChange={handleOrgChange} value={orgDetails?.staff_count} />
            </Grid>
            {data?.branding?.signature?.file_url && (
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className={classes.signatureWrap}>
                  <div className={classes.header}>
                    <div className={classes.signatureLabel}>
                   Signature
                    </div>
                    <div>
                      <Icon onClick={handleDeleteStamp} icon="material-symbols:delete-outline" width="24" height="24" style={{ color: "#b20c0cff" }} />
                    </div>
                  </div>
                  <div className={classes.signatureCard}>
                    {data?.branding?.signature?.file_url ? (
                      <img src={data?.branding?.signature?.file_url} alt="Stamp" className={classes.signatureImg} />
                    ) : (
                      <div className={classes.signatureEmpty}>No signature uploaded</div>
                    )}
                  </div>
                </div>
              </Grid>
            )}
            <Grid item lg={selectedFile ? 10 : 12} md={selectedFile ? 9 : 12} sm={12} xs={12}>
              <div>              <label className={`${classes.label}`}><p>Upload Signature</p> </label>
              </div>
              <div className={classes.pickercontainer}>
                <input type="file" className={classes.picker} onChange={handleFileChange} name="file" accept="image/jpeg,image/jpg,image/png" />

                <div className={classes.uploadflex}>
                  <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                  {selectedFile?.name ? (
                    <div>
                      <h2 className={classes.uploadtitle}>{selectedFile?.name}</h2>
                    </div>
                  ) :
                    <div>
                      <p className={classes.uploadtitle}>Tap to Upload</p>
                      <p className={classes.uploadsubtitle}>JPG/PNG | 10MB max.
                      </p>
                    </div>}
                </div>
                <div className={classes.rightpicker}>
                  {selectedFile?.name ? (
                    <div className={classes.uploadbutton} onClick={handleRemoveFile}><Icon icon="zondicons:minus-solid" /> Remove File</div>
                  ) : null}
                </div>
              </div>
            </Grid>
            <Grid item lg={2} md={2} sm={12} xs={12}>
              <div className={classes.previewGrid}>
                {selectedFile && (
                  <div className={classes.previewItem}>
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="preview"
                      className={classes.previewAnImage}
                    />
                    <div
                      className={classes.removeBtn}
                      onClick={() => handleRemoveFile()}
                    >
                      <Icon icon="zondicons:minus-solid" /> Remove
                    </div>
                  </div>
                )}
              </div>
            </Grid>

          </Grid>
          <div className={classes.btnspace}>
            <Button variant="primary" color="btndefault" buttonSize="medium" buttonName="Save Changes" onClick={updateOrg} isLoading={isLoading} />
          </div>
        </div>
      </Grid>
      {/* Delete Modal */}
      <Modal
        title="Delete Signature"
        subtitle="Are you sure you want to delete this Signature? This action cannot be undone."
        modalContent={
          <>
            <div>
            </div>
          </>
        }
        modalFooter={
          <>
            <Button
              variant="danger"
              buttonName="Delete Signature"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeleteSchoolStamp}
              isLoading={isDeleting}
            />
          </>
        }
        isopen={deleteStamp}
        closeModal={handleDeleteStamp}
      />
      {/* <ToastContainer /> */}
    </Grid>
  );
};

export default OrganisationDetails;
